module.exports = __webpack_public_path__ + "img/sevilla.98cb1f98.jpg";